import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Input, Button, Tab, Notification, Loading} from 'components/common/uiKit';
import {Info, Students, Lessons, Levels} from './tabs';
import * as RouteService from 'services/route'

import {CourseApi} from 'services/network/api';
import * as userManagement from 'services/user';


const TabsData = [
    {
        key: 'Info',
        title: '',
        component: Info,
    },
    {
        key: 'Students',
        title: '',
        component: Students,
    },
    {
        key: 'Lessons',
        title: '',
        component: Lessons,
    },
    {
        key: 'Levels',
        title: '',
        component: Levels,
    }
];

class Course extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            courseId: 0,
            data: [],
            loading: true,
            selectedTab: 0
        };
    }

    componentDidMount() {
        let courseId = 0;

        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.courseId) {
            Notification('error', 'WrongData');

            const {history} = this.props;
            history.replace({
                pathname: 'home'
            });
        }

        courseId = qs.courseId;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Tabs;

        let _tabsData = TabsData.map(x => {
            x.title = pageTranslates[x.key];
            return Object.assign(x, {params: {courseId}});
        });
        this.setState({data: _tabsData, courseId});

        this.registrationStatus(courseId);

        this.handleActiveTab();
    }

    registrationStatus(courseId) {
        CourseApi.CourseRegisterStatus(courseId)
            .then(res => {
                if (res && res.status == 200) {
                    let {data} = this.state;
                    const keys = ['lessons', 'levels'];

                    const registered = res.data.registrationType != 1;
                    data.map(x => {
                        if (keys.includes(x.key.toLowerCase()))
                            Object.assign(x, {disabled: registered})
                    });
                    this.setState({data});

                    this.checkAuth()
                }
            }).finally(() => {
            this.setState({loading: false});
        })
    }

    checkAuth() {
        //TODO: manage userRoles
        const allowed = ['Admins'];
        const userRoles = userManagement.getUserRoles();
        const isAdmin = allowed.some(x => userRoles.includes(x));

        const keys = ['students'];
        const {data} = this.state;
        data.map(x => {
            if (keys.includes(x.key.toLowerCase())) {
                Object.assign(x, {disabled: !isAdmin})
            }
        });
        this.setState({data});
    }

    handleActiveTab() {
        const {router} = this.props;
        const pushedRoute = router.filter(x => x.action.toLowerCase() == 'push');
        if (pushedRoute && pushedRoute.length > 0) {
            let last = pushedRoute.sort((a, b) => b.id - a.id)[0].location.pathname;

            if(last.includes('imageSlide'))
                last = pushedRoute.sort((a, b) => b.id - a.id)[1].location.pathname;

            if (last.includes('lesson')) {
                this.setState({selectedTab: 2});
            }
            if (last.includes('level')) {
                this.setState({selectedTab: 3});
            }
            if (last.includes('admin/level')) {
                this.setState({selectedTab: 1});
            }
        }
    }

    render() {
        const {data, loading, selectedTab} = this.state;

        if (loading) return <Loading/>;

        return (
            <div>
                <Tab value={selectedTab} data={data}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale, router} = state;
    return {locale, router};
};

export default connect(mapStateToProps, null)(withRouter(Course));


